import gql from "graphql-tag";

const TRACKING_BOARD_EXPORT_QUERY = gql`
  query TrackingBoardReportExport(
    $assetsSelected: [Int]!
    $fechaInicio: Datetime
    $fechaFin: Datetime
    $days: [WeekDaysEnum]
    $format: FormatEnum
  ) {
    trackingBoardReportExport(
      assetsSelected: $assetsSelected
      fechaInicio: $fechaInicio
      fechaFin: $fechaFin
      days: $days
      format: $format
    )
  }
`;

export default TRACKING_BOARD_EXPORT_QUERY;
